import React, { useEffect, useState } from 'react';
import {
  Button,
  LinearProgress,
  Stack,
} from '@mui/material';
import { GetDocumentSummury } from '../../adapters/GetDocumentSummury';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useNavigate } from 'react-router-dom';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';

const FileReportsSummary = ({ Patient,documentSummaryList }) => {
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);



 
 
  return (
    <React.Fragment>
      <Stack>
        {Array.isArray(documentSummaryList) ? (
          <>
            {documentSummaryList?.map((el) => (
              <Button
                variant="contained"
                key={el.ItemValue}
                sx={{
                  color: `${themeColors.ColorPrimary} !important`,
                }}
                onClick={() => {
                  const data = {
                    IdPatient: Patient.IdPatient,
                    Id: el.ItemValue,
                  };

                  GetDocumentSummury(
                    data,
                    'preview',
                    setLoading,
                    navigate,
                    screenWidth
                  );
                }}
              >
                {el?.ItemContent}
              </Button>
            ))}
            {loading ? (
              <LinearProgress sx={{ mt: '1em' }} />
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default FileReportsSummary;
